import {
  GlobalCompanyTabCompanyType,
  GlobalCompanyTabID,
  GlobalCompanyTabName,
  GlobalCompanyTabPosition,
  GlobalCompanyTabRoleUID,
  GlobalCompanyTabUUID,
  UpdateGlobalCompanyTabCacheKeys,
  UpdateGlobalCompanyTabGqlQuery
} from '../../globalCompanyTabsTypes';

import { useEdUpdateQuery } from '../../../common/reactQuery/hooks/useEdUpdateQuery';
import { ErrorType } from '../../../../utils/parseRequestError';

interface UpdateGlobalCompanyTabOptions<ItemType> {
  query: UpdateGlobalCompanyTabGqlQuery;
  cacheKeys?: UpdateGlobalCompanyTabCacheKeys;
  onSuccess?: (record: ItemType) => void;
}

export interface UpdateGlobalCompanyTabInput {
  uid: GlobalCompanyTabUUID | GlobalCompanyTabID;
  name?: GlobalCompanyTabName;
  content?: string;
  companyType?: GlobalCompanyTabCompanyType;
  position?: GlobalCompanyTabPosition;
  roleUids?: GlobalCompanyTabRoleUID[];
}

export type UpdateGlobalCompanyTabError = ErrorType;

const action = 'updateGlobalCompanyTab';

function useUpdateGlobalCompanyTab<UpdateGlobalCompanyTabRecordType = unknown>({
  query,
  cacheKeys,
  onSuccess
}: UpdateGlobalCompanyTabOptions<UpdateGlobalCompanyTabRecordType>) {
  const {
    updateQuery,
    updateQueryData,
    updateQueryError,
    updateQueryErrorMessage,
    updateQueryLoading,
    updateQueryReset
  } = useEdUpdateQuery<
    UpdateGlobalCompanyTabInput,
    UpdateGlobalCompanyTabRecordType,
    UpdateGlobalCompanyTabError,
    UpdateGlobalCompanyTabRecordType
  >({ action, query, cacheKeys, onSuccess });

  return {
    updateGlobalCompanyTab: updateQuery,
    updateGlobalCompanyTabData: updateQueryData,
    updateGlobalCompanyTabError: updateQueryError,
    updateGlobalCompanyTabErrorMessage: updateQueryErrorMessage,
    updateGlobalCompanyTabLoading: updateQueryLoading,
    updateGlobalCompanyTabReset: updateQueryReset
  };
}

export default useUpdateGlobalCompanyTab;
